
import React from 'react';
import styles from '../landing.module.scss';
import { FaRocket, FaChartPie } from 'react-icons/fa';
import { Link, useLocation, useNavigate } from 'react-router-dom';

// Login Redirect Utility
import { navigateToRegister } from '../../../utils/loginRedirect';

const MidSectionCTA = () => {
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <section className={styles.midCTASection}>
            <div className={styles.container}>
                <div className={styles.ctaContent}>
                    <h2>Ready to Level Up?</h2>
                    <div className={styles.ctaButtons}>
                        <button 
                            onClick={() => navigateToRegister(location.pathname, navigate)}
                            className={`${styles.btn} ${styles.btnPrimary}`}
                        >
                            <FaRocket /> Start exploring the VR market for free
                        </button>
                        <Link to="/profile/plans" className={`${styles.btn} ${styles.btnSecondary}`}>
                            <FaChartPie /> Analyze your first game with our plans
                        </Link>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default MidSectionCTA;
